import { createMigration } from './utils';

export const migrationTo9_205 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            // only migrate videos with music
            if (!video.get('musicId')) {
                return map;
            }
            const musicId = map.get('musicId');

            // get the max music volume override
            let maxVolume = 0;
            map.get('sceneGroups').forEach((_, i) => {
                const overrideVolume = map.getIn(['sceneGroups', i, 'musicVolumeOverride'], 0) as number;
                if (overrideVolume > maxVolume) {
                    maxVolume = overrideVolume;
                }
            });

            // set the max music volume override on the music asset and reset the scene group overrides
            video.setIn(['audioAssets', musicId, 'volume'], maxVolume);
            map.get('sceneGroups').forEach((_, i) => {
                const overrideVolume = map.getIn(['sceneGroups', i, 'musicVolumeOverride'], 0) as number;
                if (overrideVolume === maxVolume) {
                    map.setIn(['sceneGroups', i, 'musicVolumeOverride'], null);
                }
            });
        });
    },
});
